import React from "react";
import dayjs from "dayjs";

import { Col, Divider, Input, Row, Statistic } from "antd";
import { useTranslation } from "react-i18next";

import { Customer } from "../../types/model";

type BasicInfoProp = {
  customer: Customer;
};

export const BasicInfo = (props: BasicInfoProp) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[1, 8]}>
      <Col span={12}>
        <Statistic title={t("name")} value={props.customer.name} />
      </Col>
      <Col span={12}>
        <Statistic
          title={t("member_since")}
          value={dayjs(props.customer.create_time).format("YYYY/MM/DD")}
        />
      </Col>
      <Col span={12}>
        <Statistic
          title={t("email")}
          value={props.customer.email ? props.customer.email : t("na")}
        />
      </Col>
      <Col span={12}>
        <Statistic
          title={t("phone")}
          value={props.customer.phone ? props.customer.phone : t("na")}
        />
      </Col>
    </Row>
  );
};
